import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { hideButtonStatus } from '../constants/hide-button-status.constant';
import { typeRetirement } from '../constants/type-retirement.constant';

export const hideButtons = (status, deliveryType) => {
	if (status === 4 && deliveryType === typeRetirement[Enviroment.LANGUAGE].pharmacy) {
		return null;
	}
	if (hideButtonStatus[Enviroment.LANGUAGE][status]) {
		return { display: 'none' };
	}
};
